var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',_vm._g({staticClass:"button"},_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.button_text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }